import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RefundStatusLookupRoute } from '../../models/RefundStatusLookupRoute';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefundStatusRouteGuardService implements CanActivate {

  private router: Router;

  constructor(router: Router) {
    this.router = router;
  }

  public canActivate(
    activatedRouteSnapshot: ActivatedRouteSnapshot,
    routerStateSnapshot: RouterStateSnapshot
  ): boolean {
    if (RefundStatusLookupRoute.accessed) {
        return true;
    } else {
        if (RefundStatusLookupRoute.accessed && this.isPageRefresh()) {
        // alert("InProgress page Refreshed");
        return true;
        } else {
        this.router.navigate(['refund/status/lookup']);
        }
    }
  }

  /*canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // If the previous URL was blank, then the user is directly accessing this page
    if (this.router.url === '/') {
      this.router.navigate(['refund/status/lookup']); // Navigate away to lookup page
      return false;
    }
    return true;
  }*/

  private isPageRefresh(): boolean {
    return !this.router.navigated;
  }

}
